export default "__VITE_ASSET__8ffd8546__"